import { Type } from "class-transformer";
import { EnaioDeleteResultType } from "./EnaioDeleteResultType";
import { EnaioObjectTypeId } from "./EnaioObjectTypeId";

export class EnaioDeleteResult {
    type: EnaioDeleteResultType = EnaioDeleteResultType.deleted;
    @Type(() => EnaioObjectTypeId)
    objectType: EnaioObjectTypeId;
}
